// extracted by mini-css-extract-plugin
export default {"container":"Desktop_container__z75W1","content":"Desktop_content__surul","text":"Desktop_text__QyXp8","link":"Desktop_link__qKiHO"};